const FormData = require("form-data");
import axios from "axios";
import { definitions } from "./metruyenvl";
import { apiCaller } from "./metruyenvl_caller";

const uploadAPI = {
    async upload(data: definitions["do.UploadReq"]) {
        return apiCaller("/upload", "post", { header: { Authorization: "" }, body: { request: data } }) as definitions["do.UploadFileResp"];
    },

    async uploadToAWS(url: string, file: any) {
        let data = new FormData();
        data.append("file", file);

        return axios.put(url, file, {
            // headers: data.getHeaders(),
        });
    },

    async uploadCompleted(data: definitions["do.UploadedPartReq"]) {
        return apiCaller("/upload", "put", { header: { Authorization: "" }, body: { request: data } }) as definitions["do.DocumentResp"];
    },
};

export default uploadAPI;
